import React from "react";

const FORMAT_STYLES = {
  leaderboard: { width: "100%", maxWidth: 364, height: 45, label: "728×90", name: "Горизонтальный" },
  rectangle: { width: 150, height: 125, label: "300×250", name: "Прямоугольный" },
  halfpage: { width: 100, height: 200, label: "300×600", name: "Вертикальный" },
};

const MOCK_GRADIENTS = {
  minimal: "#f8f9ff",
  vivid: "linear-gradient(135deg, #ff6b35, #f7c59f)",
  premium: "linear-gradient(135deg, #1a1a2e, #0f3460)",
};

function ResizeMockup({ resize, selectedVariant, formData }) {
  const fmt = FORMAT_STYLES[resize.key] || FORMAT_STYLES.rectangle;
  const bg = MOCK_GRADIENTS[selectedVariant?.style] || "#f0f4ff";

  return (
    <div className="aic-resize-item">
      <div className="aic-resize-item__labels">
        <span className="aic-resize-item__format">{fmt.label}</span>
        <span className="aic-resize-item__name">{fmt.name}</span>
      </div>
      <div className="aic-resize-item__canvas">
        {resize.imageUrl ? (
          <img
            src={resize.imageUrl}
            alt={resize.label}
            style={{ width: fmt.width, height: fmt.height, objectFit: "cover", borderRadius: 6, display: "block" }}
          />
        ) : (
          <div
            style={{
              width: fmt.width,
              height: fmt.height,
              background: bg,
              borderRadius: 6,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px 12px",
              boxSizing: "border-box",
              overflow: "hidden",
              border: "1px solid rgba(63,115,249,0.15)",
            }}
          >
            <div style={{ fontSize: 8, fontWeight: 700, color: selectedVariant?.style === "minimal" ? "#3f73f9" : "#fff", textAlign: "center", lineHeight: 1.2, marginBottom: 4 }}>
              {formData?.brandName}
            </div>
            <div style={{ fontSize: 7, color: selectedVariant?.style === "minimal" ? "#333" : "rgba(255,255,255,0.9)", textAlign: "center", lineHeight: 1.2 }}>
              {formData?.headline?.slice(0, 30)}
            </div>
          </div>
        )}
      </div>
      <button
        className="aic-btn aic-btn--outline aic-btn--sm"
        onClick={() => resize.imageUrl && window.open(resize.imageUrl, "_blank")}
        disabled={!resize.imageUrl}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Скачать
      </button>
    </div>
  );
}

function ResizesModal({ resizes, isLoading, selectedVariant, formData, onClose, onSaveToLibrary }) {
  return (
    <div className="aic-modal-overlay" onClick={onClose}>
      <div className="aic-resizes-modal" onClick={(e) => e.stopPropagation()}>
        <div className="aic-resizes-modal__header">
          <div>
            <h3 className="aic-resizes-modal__title">Ресайзы баннера</h3>
            <p className="aic-resizes-modal__subtitle">Стиль: {selectedVariant?.label}</p>
          </div>
          <button className="aic-resizes-modal__close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="#666" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {isLoading ? (
          <div className="aic-resizes-modal__loading">
            <div className="aic-spinner" />
            <p>Генерируем ресайзы...</p>
          </div>
        ) : (
          <>
            <div className="aic-resizes-modal__grid">
              {resizes.map((r) => (
                <ResizeMockup
                  key={r.key}
                  resize={r}
                  selectedVariant={selectedVariant}
                  formData={formData}
                />
              ))}
            </div>

            <div className="aic-resizes-modal__footer">
              <button className="aic-btn aic-btn--primary" onClick={onSaveToLibrary}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M17 21v-8H7v8M7 3v5h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                Сохранить в библиотеку
              </button>
              <button className="aic-btn aic-btn--ghost" onClick={onClose}>
                Закрыть
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ResizesModal;
